export enum Brands {
  REGUS = 'regus',
  SPACES = 'spaces',
  STOP_AND_WORK = 'stopandwork'
}

// Bump the version suffix and rename the matching CSS file in src/assets/themes/
// whenever a theme's contents change, so deployed clients pick up the new file.
export const THEME_FILES: Record<Brands, string> = {
  [Brands.REGUS]: '_css-variables.regus.v2.css',
  [Brands.STOP_AND_WORK]: '_css-variables.stopandwork.v2.2.css',
  [Brands.SPACES]: '_css-variables.spaces.v2.1.css',
};
export const SPACES = 'spaces' as const;
export const REGUS = 'regus' as const;
export const STOP_AND_WORK = 'stopandwork' as const;

export type Brand = typeof SPACES | typeof REGUS | typeof STOP_AND_WORK;

export const BRAND_HOSTS: Record<string, string> = {
  [REGUS]: 'regus.com',
  [SPACES]: 'spacesworks.com',
  [STOP_AND_WORK]: 'stopandwork.com'
};

export const BRAND_GTM_BASE_URLS = {
  [REGUS]: `https://gtm.${BRAND_HOSTS[REGUS]}/gtm.js`,
  [STOP_AND_WORK]: `https://www.googletagmanager.com/gtm.js`,
  [SPACES]: `https://www.${BRAND_HOSTS[SPACES]}/sgtm/gtm.js`
};

// Extra GTM containers (data layers) to be loaded in addition to the brand's main one.
// `gtmIdKey` refers to the key on `environment.googleAnalyticsKeys`/`environment` used to look up the GTM container id.
export interface AdditionalGtmContainer {
  baseUrl: string;
  layerName: string;
  gtmIdKey: string;
}

export const BRAND_ADDITIONAL_GTM_CONTAINERS: Partial<Record<Brand, AdditionalGtmContainer[]>> = {
  [REGUS]: [
    {
      baseUrl: BRAND_GTM_BASE_URLS[REGUS],
      layerName: 'dataLayerRegus',
      gtmIdKey: 'dataLayerRegus'
    }
  ]
};

export type FooterLinks = Record<string, string>;

export const BRAND_FOOTER_LINKS: FooterLinks = {
    'legal/online-privacy-policy': 'privacyPolicy',
    'legal/client-terms-and-conditions': 'termsAndConditionsSimplified',
    'legal/client-cookie-policy': 'cookiePolicy'
};

export const APP_STORE_LINK = {
  [REGUS]: 'https://itunes.apple.com/gb/app/regus/id387924487',
  [STOP_AND_WORK]: 'https://apps.apple.com/ee/app/iwg-hybrid-working-platform/id1583741979',
  [SPACES]: 'https://apps.apple.com/ee/app/spaces-creative-workspaces/id1264571107'
};
export const PLAY_STORE_LINK = {
  [REGUS]: 'https://play.google.com/store/apps/details?id=com.regus',
  [STOP_AND_WORK]: 'https://play.google.com/store/apps/details?id=com.iwgplc.iwg',
  [SPACES]: 'https://play.google.com/store/apps/details?id=com.spacesworks'
};
